import { getApi } from './player';
import queryString from 'query-string';

const ADD_PRODUCT = 'ADD_PRODUCT';
const SET_ACTIVE_PRODUCT = 'SET_ACTIVE_PRODUCT';
const SET_IMGASSET = 'SET_IMGASSET';
const SET_SHARE_STATE = 'SET_SHARE_STATE';
const SET_ADDTIONAL_ATTRIBUTES = 'SET_ADDTIONAL_ATTRIBUTES';
const API_URL = 'https://mythreekit.com/api/organizations/silq/orders';
const sceneId = '0e89064d-60bf-443e-a541-170b49ab75f0';
const form = 'main';
const publishedHash = '21d61cc50bc134532477796ae3e13a64';
const productId = '5b0838a6e036250001c9dc87';
const initialState = {
  products: {
    'Seagull + Artic White Gloss': {
      name: 'Seagull + Artic White Gloss',
      sceneId,
      publishedHash,
      form,
      productId,
    },
    'Merle + Black Gloss': {
      name: 'Merle + Black Gloss',
      sceneId,
      publishedHash,
      form,
      productId,
    },
    'Merle + Black Gloss/ Dark Glitch': {
      name: 'Merle + Black Gloss/ Dark Glitch',
      sceneId,
      publishedHash,
      form,
      productId,
    },
    'Merle + Black/Blazer Quilt': {
      name: 'Merle + Black/Blazer Quilt',
      sceneId,
      publishedHash,
      form,
      productId,
    },
    'Seagull + Carbon Metallic / Melange': {
      name: 'Seagull + Carbon Metallic / Melange',
      sceneId,
      publishedHash,
      form,
      productId,
    },
  },
  active: {
    name: 'Seagull + Artic White Gloss',
    sceneId,
    publishedHash,
    form,
    productId,
  },
  images: {},
  addtionalAttributes: {},
  shareState: 'none',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_PRODUCT:
      const activeProd = state.products[action.payload];
      return { ...state, active: activeProd };
    case SET_IMGASSET:
      const images = Object.assign({}, state.images, action.payload);
      return { ...state, images };
    case SET_ADDTIONAL_ATTRIBUTES:
      const addtionalAttributes = Object.assign(
        {},
        state.addtionalAttributes,
        action.payload
      );
      return { ...state, addtionalAttributes };
    case SET_SHARE_STATE:
      return { ...state, shareState: action.payload };
    default:
      return state;
  }
};

export const setActiveProduct = product => ({
  type: SET_ACTIVE_PRODUCT,
  payload: product,
});

export const getProducts = state => state.products.products;
export const getActiveProduct = state => state.products.active;
export const setShareState = v => {
  return (dispatch, getState) => {
    dispatch({ type: SET_SHARE_STATE, payload: v });
  };
};
const setModalButton = (res, action, dispatch) => {
  if (res) {
    const button = document.getElementById('modalSumit');
    if (button) button.innerHTML = `${action}`;
    dispatch(setShareState(action));
  } else {
    const button = document.getElementById('modalSumit');
    if (button) {
      button.innerHTML = `${action} (faild)`;
      setTimeout(() => {
        button.innerHTML = `${action}`;
      }, 3000);
    }
  }
};
export const shareOrder = (type, user) => {
  return async (dispatch, getState) => {
    const state = getState();
    const api = getApi(state);
    const product = getActiveProduct(state);
    if (api) {
      const configuration = api.configuration.getConfiguration();
      const attr = {
        sceneId: product.sceneId,
        productId: product.productId,
        configuration,
        customer: {
          name:
            user.firstname || user.lastname
              ? user.firstname + ' ' + user.lastname
              : '',
          email: user.email,
          message: user.message,
        },
        metadata: {
          cameraId:
            configuration['Height'] === 'Standard Height'
              ? api.scene.find('Camera_init')
              : api.scene.find('Camera_init1'),
          dealerEmail: user.dealeremail || localStorage.getItem('dealeremail'),
        },
      };

      if (type === 'email') {
        const res = await createOrder(attr);
        setModalButton(res, type, dispatch);
      } else if (type === 'print') {
        const res = await printPdf(attr);
        setModalButton(res, type, dispatch);
        return res;
      } else if (type === 'facebook') {
        attr.type = 'share';
        shareDesign('facebook', attr);
      } else if (type === 'twitter') {
        attr.type = 'share';
        shareDesign('twitter', attr);
      } else {
        console.log('Unknow type of action', type);
      }
    }
  };
};

const width = 500;
const height = 500;
const leftPosition = window.screen.width / 2 - (width / 2 + 10);
const topPosition = window.screen.height / 2 - (height / 2 + 50);
const windowSetting = `'status = 1, height = ${height}px, width = ${width}px, resizable = 1, left=${leftPosition}, top=${topPosition}, screenX=${leftPosition}, screenY=${topPosition}`;

const shareDesign = (type, attr) => {
  // const hash = this.props.hash || this.state.hash;
  // if (hash) return buildShareLink(type, { hash, sceneId }, 'silq');
  //This is a hacky solution as we could not pop up window in promise, as it is not user triggered event and browser would block it.
  let newTab = window.open(
    `${window.location.origin}/cloud_load.gif`,
    '',
    windowSetting
  );
  createOrder(attr, 'share').then(data => {
    data.sceneId = attr.sceneId;
    data.configuration = attr.configuration;
    buildShareLink(type, data, 'silq', newTab);
    // this.setState({ hash: data.hash });
  });
};

const buildShareLink = async (type, data, slug, tab) => {
  const rawShareUrl = `https://${slug}.mythreekit.com?configuration=${JSON.stringify(
    data.configuration
  )}`;
  const shareUrl = data.shortenUrl;
  const ImageUrl = `https://clara.io/api/scenes/${data.sceneId}/v2thumbnail`;
  let settings = {};
  switch (type) {
    case 'facebook':
      settings = {
        title: 'Post to Facebook',
        url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          shareUrl
        )}&amp;src=sdkpreparse`,
      };
      break;
    case 'twitter':
      settings = {
        title: 'Share a link on Twitter',
        url: `https://twitter.com/intent/tweet?text=Check my latest SILQ design!&url=${encodeURIComponent(
          shareUrl
        )}`,
      };
      break;
    case 'googleplus':
      settings = {
        title: 'Post to Google Plus',
        url: `https://plus.google.com/share?url=${encodeURIComponent(
          shareUrl
        )}`,
      };
      break;
    case 'pinterest':
      settings = {
        title: 'Pin it',
        url: `https://pinterest.com/pin/create/button?url=${encodeURIComponent(
          shareUrl
        )}&media=${ImageUrl}`,
      };
      break;
    default:
      break;
  }
  if (tab) {
    tab.location.href = settings.url;
    tab.location.title = settings.title;
  } else {
    window.open(settings.url, settings.title, windowSetting);
  }
};

const createOrder = async (attr, type = null) => {
  const apiRoot = `https://mythreekit.com/api/organizations/silq/orders`;
  if (type) {
    attr.type = type;
  }
  const result = await fetch(apiRoot, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(attr),
  }).then(async res => {
    if (res.status === 200) {
      return await res.json();
    }
    return null;
  });
  return result;
};

const printPdf = async attr => {
  // const apiRoot = `/api/pdf`;
  // const result = await fetch(apiRoot, {
  //   method: 'POST',
  //   headers: new Headers({
  //     'Content-Type': 'application/json',
  //   }),
  //   body: JSON.stringify(attr),
  // }).then(async res => {
  //   if (res.status === 200) return await res.blob();
  //   return null;
  // });

  const { configuration, metadata } = attr;
  const { cameraId } = metadata;
  configuration['render'] = configuration['Casters'];
  const renderOptions = {
    width: 1500,
    height: 1500 / 0.7047,
    cache: false,
    renderer: 'webgl',
    cameraId,
    configuration: JSON.stringify(configuration),
    url: true,
  };
  const renderURL = `https://clara.io/api/scenes/${sceneId}/render?${queryString.stringify(
    renderOptions
  )}`;

  const res = await fetch(renderURL).then(async res => {
    if (res.status === 200) return await res.json();
    return null;
  });
  return res && res.url ? res.url : null;
};

export const socialShare = type => {
  return (dispatch, getState) => {};
};

export const setImageAssets = (product, imgs) => ({
  type: SET_IMGASSET,
  payload: { [product]: imgs },
});

export const getActiveImageAssets = state => {
  const activeSceneId = getActiveProduct(state).sceneId;
  return state.products.images[activeSceneId];
};

export const setAddionalAttribues = (product, attributes) => ({
  type: SET_ADDTIONAL_ATTRIBUTES,
  payload: { [product]: attributes },
});

export const getActiveAddionalAttributes = state => {
  const activeSceneId = getActiveProduct(state).sceneId;
  return state.products.addtionalAttributes[activeSceneId];
};



// WEBPACK FOOTER //
// ./src/modules/products.js